/* unplugin-vue-components disabled */import { render } from "./teacherCard.vue?vue&type=template&id=aa119000&scoped=true"
import script from "./teacherCard.vue?vue&type=script&lang=js"
export * from "./teacherCard.vue?vue&type=script&lang=js"

import "./teacherCard.vue?vue&type=style&index=0&id=aa119000&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa119000"]])

export default __exports__